export const parseRawFeatureFlagValue = (rawValue: string): unknown => {
  if (rawValue === 'true') {
    return true;
  }

  if (rawValue === 'false') {
    return false;
  }

  if (rawValue === 'null') {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch {
    return rawValue;
  }
};

export const parseFeatureFlagValue = <T>(rawValue: string | undefined, defaultValue: T): T => {
  if (rawValue === undefined) {
    return defaultValue;
  }

  if (typeof defaultValue === 'boolean') {
    if (rawValue === 'true') return true as T;
    if (rawValue === 'false') return false as T;
  }

  if (typeof defaultValue === 'number') {
    const parsedNumber = Number(rawValue);

    if (!Number.isNaN(parsedNumber)) {
      return parsedNumber as T;
    }
  }

  if (typeof defaultValue === 'string') {
    return rawValue as T;
  }

  try {
    return JSON.parse(rawValue) as T;
  } catch {
    return defaultValue;
  }
};

export const buildFeatureFlagMap = (flags: Array<{ key: string; value: string }>): Record<string, unknown> => {
  return flags.reduce<Record<string, unknown>>((acc, flag) => {
    acc[flag.key] = parseRawFeatureFlagValue(flag.value);

    return acc;
  }, {});
};
